import React from 'react'
import NavbarComp from './NavbarComp';
import Pic from './pic';
import Row from 'react-bootstrap/Row'
import Footer from './Footer'

const Gallery = () => {
    return ( 
        <div className='bg-light' >
<NavbarComp />
<h1 className="exee text-center mt-5">Photo Gallery</h1>
<p className='text-center text-mute mt-3 '>Photographs and videos reminds us of what was important to us.It triggers memories that are long gone faded and brings them back to life.Watch photos and videos of past events, programs, and happenings at AMCOSA and our dear Alma Mater.</p>
<div>
 <Row>
    <Pic img={'am1'} />
    <Pic img={'am2'} />
    <Pic img={'am3'} />
    <Pic img={'am4'} />
    <Pic img={'am5'} />
    <Pic img={'am6'} />
    <Pic img={'am7'} />
    <Pic img={'am9'} />
    <Pic img={'am10'} />
    <Pic img={'am11'} />
    <Pic img={'am21'} />
    <Pic img={'am13'} />
    <Pic img={'am22'} />
    <Pic img={'am23'} />
    <Pic img={'am15'} />
    <Pic img={'am16'} />
    <Pic img={'am19'} />
    <Pic img={'ram2'} />
    </Row>
</div>
<Footer />
        </div>
     );
}
 
export default Gallery;